export interface ApiError {
  error: string;
}

export class HttpError extends Error {
  constructor(
    public status: number,
    message: string,
    public data?: ApiError
  ) {
    super(message);
    this.name = 'HttpError';
  }
}

